import React, { useContext, useMemo } from "react";
import { WdprNavItemSmall } from "components/vista";
import { addCurrentRedirectUrl } from "utils";
import { Context } from "Context";
import AnalyticsWrapper from "components/shared/AnalyticsWrapper";

const SignOutButton = ({
	handleLogout,
	className,
	animationClasses,
	animationDelay,
}) => {
	const {
		headerData: { chrome },
		config: { shouldInvertItems },
		updatedLocation,
	} = useContext(Context);

	const logoutRedirectUrl = useMemo(() => {
		const signOutHref = chrome?.signOut?.href || "/authentication/logout/";
		if (!updatedLocation) return signOutHref;
		return addCurrentRedirectUrl(signOutHref, false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [chrome?.signOut?.href, updatedLocation]);

	if (!chrome.signOut) return null;

	return (
		<AnalyticsWrapper analyticsLinkId={chrome.signOut.analyticsLinkId}>
			<WdprNavItemSmall
				label={chrome.signOut.title}
				onClick={(e) => {
					handleLogout(e, logoutRedirectUrl);
				}}
				className={`${className} ${animationClasses ?? ""}`}
				style={animationDelay ? { animationDelay } : undefined}
				inverse={shouldInvertItems}
			/>
		</AnalyticsWrapper>
	);
};
export default SignOutButton;
